import React, { FC } from 'react';
import { DateTimeDisplay } from 'src/ui/white-labels/nftsuperlab/atoms/countdown/date-time-display';
import { StyledShowCounterWrapper } from 'src/ui/white-labels/nftsuperlab/atoms/countdown/show-counter/styles';

interface IProps {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export const ShowCounter: FC<IProps> = ({ days, hours, minutes, seconds }) => (
    <StyledShowCounterWrapper>
        <DateTimeDisplay value={days} type="dage" />
        <DateTimeDisplay value={hours} type="timer" />
        <DateTimeDisplay value={minutes} type="min" />
        <DateTimeDisplay value={seconds} type="sek" />
    </StyledShowCounterWrapper>
);
